// Mobile breakpoint for this page. Fires the theme's 'mediaChange' event when crossing it so the
// gallery, thumbs and sticky elements re-evaluate, same as they do at the theme breakpoints.
window.newProductMainMedia = window.newProductMainMedia || (function() {
  const query = '(max-width: 850px)';
  const mq = window.matchMedia(query);
  mq.addEventListener('change', ()=>window.dispatchEvent(new Event('mediaChange')));
  return {
    query,
    isSmall: ()=>mq.matches
  };
})();

if(!customElements.get('product-main')) {
  class ProductMain extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.section;
      this.productData = JSON.parse(this.querySelector('[type="application/json"][data-product-json]').textContent);
      this.variantsElement = this.querySelector('product-variants');
      this.sellingPlanElement = this.querySelector('product-selling-plan');
      this.quantityElement = this.querySelector('.quantity-input');
      this.badgesSale = this.querySelectorAll('.badge.sale');
      this.badgesSoldOut = this.querySelectorAll('.badge.sold-out');
      this.variantTitleElements = this.querySelectorAll('[data-variant-title]');
      this.optionValues = {}
      const requiredOptionsSetting = ([] || []).concat(this.dataset.manualSelect ? this.dataset.manualSelect.split(',') : []).map(x=>x.trim());
      const requiredOptionsSettingUnique = [...new Set(requiredOptionsSetting)];
      this.requiredOptions = this.productData.options.filter(x=>(requiredOptionsSettingUnique.indexOf(x)>-1 || requiredOptionsSettingUnique.indexOf('*')>-1) && this.getOptionValues(x).length>1);
      if (this.requiredOptions.length > 0) {
        this.setAttribute('data-required', 'true');
      }
      if (this.quantityElement) {
        this.quantityElement.addEventListener('change', this.onQuantityElementChange.bind(this));
      }
      this.addEventListener('variantChange', this.onVariantChange.bind(this));
    }

    getOptionValues(optionName) {
      if (!this.optionValues[optionName]) {
        function filterUnique(value, index, array) {
          return array.indexOf(value) === index;
        }
        var ix = this.productData.options.indexOf(optionName);
        this.optionValues[optionName] = this.productData.variants.map(v=>v['option'+(1+ix)]).filter(filterUnique);
      }
      return this.optionValues[optionName];
    }

    isSwatchSelected() {
      return this.requiredOptions.length == 0 || this.requiredOptions.length < this.productData.options.length;
    }

    required(option, newValue) {
      var ix = this.requiredOptions.indexOf(option);
      if (typeof(newValue)!='undefined') {
        if (ix > -1) {
          this.requiredOptions.splice(ix, 1);
          if (this.requiredOptions.length == 0) {
            this.setAttribute('data-required', 'false');
          }
          return false;
        }
      }
      return ix > -1;
    }

    getCurrentVariant() {
      return this.variantsElement.getCurrentVariant();
    }
    getCurrentPlan() {
      return this.sellingPlanElement?.getCurrentPlan();
    }
    getQuantity() {
      return this.quantityElement ? this.quantityElement.value : 1;
    }
    onQuantityElementChange() {
      this.dispatchEvent(new CustomEvent('quantityChange', {detail: {"quantity":this.getQuantity()}}));
    }
    onVariantChange() {
      //lightweight update of elements that not worth creating their own components
      var variant = event.detail.variant;
      this.variantTitleElements.forEach(element=>{
        element.innerHTML = variant.title;
      });
      this.badgesSale.forEach(element=>{
        var sale = '';
        var percent = Math.floor((1 - variant.price / variant.compare_at_price) * 100);
        if (percent > 0) {
          sale = element.dataset.msgtpl.replace('[percent]', percent);
        }
        element.style.display = sale ? '' : 'none';
        element.innerHTML = sale;
      });
      this.badgesSoldOut.forEach(element=>{
        element.style.display = variant.available ? 'none' : '';
      });}
  }
  customElements.define('product-main', ProductMain);

  class ComponentProductCardAtc extends ProductMain {
    constructor() {
      super()
      this.swatches = this.querySelector('.swatch-group')
      this.addEventListener('variantChange', this.onVariantChange.bind(this));
      this.defaultImage = this.querySelector('.img.main').getAttribute('data-srcset');
      this.currentImageUrl = '';
      this.imageObserver = null;
      this.clickOutHandler = null;
      let imageContainer = this.querySelector('.image-container');
      if (imageContainer && imageContainer.querySelector('.hover-img')) {
        let hover = false;
        this.addEventListener('mouseleave', (e)=>{
          hover && (hover=false,imageContainer.classList.remove("hover"));
        });
        this.addEventListener('mousemove', (e)=>{
          let bounds = imageContainer.getBoundingClientRect();
          if (e.y>bounds.top && e.y<bounds.bottom && e.x>bounds.left && e.x<bounds.right) {
            hover || (hover=true,imageContainer.classList.add("hover"))
          } else {
            hover && (hover=false,imageContainer.classList.remove("hover"));
          }
        });
      }
      
      this.optionsButton = this.querySelector('.atc-options');
      if (this.optionsButton) {
        this.optionsButton.addEventListener('click', this.openOptions.bind(this));
      }

      this.quickViewBtn = this.querySelector('.quick-view-trigger')
      if(this.quickViewBtn) {
        this.quickViewBtn.addEventListener('click', this.openQuickView.bind(this));
      }

      var self = this;
      if (self.classList.contains('colors-out')) {
        setTimeout(function() { //workaround on ajax call, the following code mistakenly inits ProductSwatch before ProductVariants
          var origSwatches = self.querySelector('product-swatch.color-swatches');
          if (origSwatches) {
            //need to duplicate the whole product-variants component
            var pv = origSwatches.closest('product-variants');
            var tag = pv.outerHTML.replace('name="id"', '');
            var wrapper = document.createElement('div');
            wrapper.style.display = 'none';
            //must insert as Element, not HTML, otherwise the component would be reconstructed
            self.querySelector('add-to-cart-form').insertAdjacentElement('beforebegin', wrapper);
            wrapper.innerHTML = tag;
            //move the swatches inside the add-to-cart-form component to use existing css.
            self.querySelector('add-to-cart-form').insertAdjacentElement('afterbegin', wrapper.querySelector('product-swatch.color-swatches'));
          }
        }, 10);
      }
      if (window.LinkPrefetch && window.LinkPrefetch.addHoverListener) {
        window.LinkPrefetch.addHoverListener(this);
      }
    }

    openOptions(e) {
      e.preventDefault()
      var container = this.querySelector('.atc-options-wrapper form');
      this.querySelector('.atc-options-wrapper').classList.add('open');
      $s.trapFocus(container);
      var self = this;
      if (!this.clickOutHandler) {
        this.querySelector('.close').addEventListener('click', this.closeOptions.bind(this));
      }
      this.clickOutHandler = function(evt) {
        if(container !== evt.target && !container.contains(evt.target)) {
          self.closeOptions.bind(self)();
        }
      }
      document.addEventListener('mousedown', this.clickOutHandler);
    }
    closeOptions() {
      this.querySelector('.atc-options-wrapper').classList.remove('open');
      document.removeEventListener('mousedown', this.clickOutHandler);
      $s.removeTrapFocus();
    }

    openQuickView(e) {
      e.preventDefault()
      $s.showLoadingOverlay();
      var qvUrl = this.quickViewBtn.dataset.url;
      $s.get({
        url: qvUrl,
        success: (html)=>{
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var section = doc.querySelector('.product-main-element').closest('.shopify-section');
          var enhancedDescription = section.querySelector('.enhanced-description');
          if (enhancedDescription && enhancedDescription.querySelector('.expandable-default-open')) {
            enhancedDescription.querySelector('.accordion.open').classList.remove('open');
            enhancedDescription.querySelector('[aria-expanded=true]').ariaExpanded = false;
            enhancedDescription.querySelector('.expandable-default-open').classList.remove('expandable-default-open');
          }
          $s.openModal(section, 'product-quick-view');
          $s.globalEval(section);
        },
        always: (html)=>{
          $s.hideLoadingOverlay();
        }
      })
    }

    onVariantChange(event) {
      console.log('test');
      super.onVariantChange(event);
      var variant = event.detail.variant;
      var image = variant.featured_media && super.isSwatchSelected() ? variant.featured_image : null;
      var img = this.querySelector('.img.main');
      var width = Math.ceil(img.width / 100) * 100;
      if (image && img.classList.contains('under-video')) {
        this.querySelector('.video-wrap').remove();
        img.classList.remove('under-video');
      }

      if (img.classList.contains('lazyload')) {
        img.setAttribute('data-srcset', image ? $s.buildImgSrcset(image.src, image.width) : this.defaultImage);
      } else {
        this.currentImageUrl = image ? $s.buildImgSrcset(image.src, image.width) : this.defaultImage;
        if (!this.imageObserver) {
          if (!img.classList.contains('lazyloaded')) {
            this.imageObserver = new MutationObserver(mutations => {
              if (img.classList.contains('lazyloaded')) {
                this.imageObserver.disconnect();
                this.imageObserver = null;
                img.setAttribute('srcset', this.currentImageUrl);
              }
            });
            var config = { attributes: true, attributeFilter: ['class']};
            this.imageObserver.observe(img, config);
          } else {
            img.setAttribute('srcset', this.currentImageUrl);
          }
        }
      }

      //update urls to variant
      var links = this.querySelectorAll('.product-card-url[href]');
      if (links.length > 0 && this.requiredOptions.length < this.productData.options.length) {
        var productUrl = new URL(links[0].getAttribute('href'), location.origin);
        productUrl.searchParams.set('variant', variant.id);
        links.forEach(link=>{
          link.setAttribute('href', productUrl.toString());
        });
        if (this.quickViewBtn) {
          this.quickViewBtn.dataset.url = productUrl.toString();
        }
      }
    }
  }
  customElements.define('product-card-atc', ComponentProductCardAtc);
}

if(!customElements.get('product-buttons')) {
  class ProductButtons extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.dynamicButtons = (this.closest('.sticky-atc-row') || this.closest('.module'))?.querySelector('.shopify-payment-button') || null;
      this.mainAddButton = this.mainElement.querySelector('.btn.add');
      this.button = this.querySelector('.btn.add');

      this.selectedVariant = null;
      this.bundleVariants = [];
      this.eventListeners = ['variantChange', 'bundleVariantChange']

      if(this.button) {
        if (this.button != this.mainAddButton) {
          this.button.addEventListener('click', (event)=>{
            event.preventDefault();
            event.stopImmediatePropagation();
            this.mainAddButton.click();
          });
        }
      } 

      this.mainElement.addEventListener('bundleVariantChange', (e)=>{
        this.bundleVariants = e.detail;
        this.validateAtc(e)
      });

      this.mainElement.addEventListener('variantChange', (e)=> {
        this.selectedVariant = e.detail.variant;

        var velvetProduct = document.querySelector('.velvet_product');
         var velvetProductBtn = document.querySelector('.velvet_product .btn.add');
        var selectedId = this.selectedVariant.id;

        if (velvetProduct) {
            fetch('/cart.js')
              .then(response => response.json())
              .then(cart => {
                // Check if the product already exists in the cart
                const exists = cart.items.some(item => {
                  return item.id == selectedId;
                });

                // Enable or disable button based on match
                if (exists) {
                  velvetProductBtn.classList.add('disabled');
                  velvetProductBtn.setAttribute('disabled', 'disabled');
                } else {
                  velvetProductBtn.classList.remove('disabled');
                  velvetProductBtn.removeAttribute('disabled');
                }
              })
              .catch(error => console.error('Error fetching cart:', error));
          }

        this.validateAtc(e)
      });
    }

    validateAtc(e) {

      var variantItem = document.querySelector(`.product_varaint_hidden .varaint_item[data-value="${this.selectedVariant.title}"]`);
      // Pre-order comes from variant inventory (see stock status in new_product_main.liquid)
      var preorderVariantIds = (this.mainElement.dataset.preorderVariantIds || '').split(',');
      var variantData = this.selectedVariant && preorderVariantIds.includes(String(this.selectedVariant.id)) ? 'true' : null;

      var variantPreorder = variantItem ? variantItem.getAttribute('data-preordermsg') : null;

      var variantSoldout = variantItem ? variantItem.getAttribute('data-soldout') : null;

      var variantInventoryUrgency = variantItem
  ? variantItem.getAttribute('data-inventory-urgency')
  : null;

   var variantInventoryPercentage = variantItem
  ? variantItem.getAttribute('data-urgency-percentage')
  : null;

      var validatedVariants = this.selectedVariant && this.selectedVariant.available;
    
     var inventoryUrgencyModule = document.querySelector('.module.inventory-urgency');


if (variantItem && inventoryUrgencyModule) {
  if (variantInventoryUrgency && variantInventoryUrgency !== 'null') {
    inventoryUrgencyModule.style.display = '';
    
    var inventoryUrgencyCount = inventoryUrgencyModule.querySelector('.inventory-urgency-count');
    if (inventoryUrgencyCount) {
      inventoryUrgencyCount.textContent = variantInventoryUrgency;
      if (
        variantInventoryPercentage &&
        document.querySelector('.inventory-urgency-bar span[data-inventory-urgency-bar]')
      ) {
        document.querySelector('.inventory-urgency-bar span[data-inventory-urgency-bar]').style.width =
          variantInventoryPercentage + '%';
      }
    }
  } else {
    inventoryUrgencyModule.style.display = 'none';
  }
}

      if (this.bundleVariants.length > 0) {
        validatedVariants = validatedVariants && this.bundleVariants.reduce((tot, variant) => tot && variant.available, true);
      }

      var requiredBtn = this.querySelector('.btn.selection-required');
      const bisButton = document.querySelector('#klaviyo-bis-button-container');


        if (this.required() && requiredBtn) {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.add('hide');
          }
          requiredBtn.style.display = '';
          requiredBtn.innerHTML = this.requiredMessage;
        } else if(validatedVariants) {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.remove('hide');
          }
          this.querySelector('.btn.add') && (this.querySelector('.btn.add').style.display = '');
          const addButton = this.querySelector('.btn.add');

          if (addButton) {
            var addButtonText = addButton.getAttribute('data-atc');
          }
          
          var preOrderMsg = document.querySelector('.pre-order-msg');
          var estimatedShippingMsg = document.querySelector('.delivery_date_shortcode');
          if (variantData !== null && variantData === "true") {
            if (addButton) {  
              addButton.textContent = 'PRE-ORDER';
            }
            if(estimatedShippingMsg){
              estimatedShippingMsg.style.display = 'none';
            }
            if(preOrderMsg){
              preOrderMsg.style.display = 'block';
              preOrderMsg.innerHTML = variantPreorder;
            }
          } else if (addButtonText) {
            if (addButton) {
                addButton.textContent = addButtonText;
            }
            if(preOrderMsg){
              preOrderMsg.style.display = 'none';
            }
             if(estimatedShippingMsg){
              estimatedShippingMsg.style.display = 'block';
            }
          } else {
            if (addButton) {
              addButton.textContent = 'Add to Cart';
            }
            if(preOrderMsg){
              preOrderMsg.style.display = 'none';
            }
            
             if(estimatedShippingMsg){
              estimatedShippingMsg.style.display = 'block';
            }
          }




          
          this.querySelector('.sold-out-message').style.display = 'none';
          if (requiredBtn) requiredBtn.style.display = 'none';
          if (bisButton) {
                bisButton.style.display = 'none'; 
          }

        const klaviyoButton = document.querySelector('#klaviyo-bis-button-container');


          if (klaviyoButton) {    
            klaviyoButton.style.display = 'none';
          }

          

      	} else {

          var preOrderMsg = document.querySelector('.pre-order-msg');
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.add('hide');
          }
       

         if (!variantSoldout) {
          this.querySelector('.btn.add') && (this.querySelector('.btn.add').style.display = 'none');
         }
          
          setTimeout(() => {
            this.querySelector('.sold-out-message').style.display = '';
            if(preOrderMsg){
                preOrderMsg.style.display = 'none';
              }
          }, 500);

          if (requiredBtn) requiredBtn.style.display = 'none';
           if (bisButton) {
                bisButton.style.display = ''; 
          }
      	}
    }

    required() {
      if (this.mainElement.requiredOptions.length > 0) {
        this.requiredMessage = '';
        var label = this.mainElement.requiredOptions[0];
        var firstLetter = label[0].toLowerCase();
        var prep = 'aeiou'.indexOf(firstLetter)>-1 ? 'an' : 'a'; //english support only
        this.requiredMessage = lngg.product_main__select_option_label.replace('Select a ', 'Select ' + prep + ' ').replace(new RegExp(/{{ *option_name *}}/), label);
        return true;
      }
      return false;
    }
  }
  customElements.define('product-buttons', ProductButtons);
}

if(!customElements.get('product-sku')) {
  class ProductSKU extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');

      this.mainElement.addEventListener('variantChange', (e)=>{
      	if(e.detail.variant) {
          if(e.detail.variant.sku) {
            this.closest('.module').style.display = 'block';
            this.innerHTML = e.detail.variant.sku;
          }else{
            this.closest('.module').style.display = 'none';
          }
      	}
      });
    }
  }
  customElements.define('product-sku', ProductSKU);
}

if(!customElements.get('product-gallery') && !customElements.get('product-thumbs')) {
  class ProductMedia extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.itemsWrapper = this.querySelector('.items-wrapper');
      this.desktopStyle = this.dataset.desktop;
      this.desktopOrientation = this.dataset.desktopOrientation;
      this.mobileStyle = this.dataset.mobile;
      this.collageGrid = this.dataset.collageGrid === 'true';
      this.collageSeed = parseInt(this.dataset.collageSeed)
      this.slider = false;

      this.mainElement.addEventListener('variantChange', this.onVariantChange.bind(this))
      window.addEventListener('mediaChange', this.onMediaChange.bind(this))
      setTimeout(()=>{
        this.onMediaChange();
      }, 10);
    }

    filterMedia(variant, additionalFilters) {
      this.mainElement.productData.media.forEach((media)=>{
        var show = true;
        if(media.alt && media.alt!="") {
          var filter = media.alt.split(';');
          filter.forEach((f)=>{
            
            if(show) {
              var key = f.split(':')[0];
              var values = f.split(':')[1];
              /*
              var optionIndex = this.mainElement.productData.options.findIndex(x=>x==key.trim());
              if(optionIndex>=0 && values) {
                var found = false;
                values.split(',').forEach((value)=>{
                  if(variant.options[optionIndex]==value.trim()) {
                    found = true;
                  }
                });
                show = found;
              }*/
              if (key.trim() === 'Bundles') {
                var found = false;
                if (additionalFilters) {
                  if (values.split(',').sort((a, b) => a < b ? 1 : -1).filter(a => a).map(a => a.trim()).join('+') === additionalFilters.split(',').sort((a, b) => a < b ? 1 : -1).filter(a => a).map(a => a.trim()).join('+')) {
                    found = true;
                  }
                }
                show = found;
              } else {
                var optionIndex = this.mainElement.productData.options.findIndex(x=>x==key.trim());
                if(optionIndex>=0 && values) {
                  var found = false;
                  values.split(',').forEach((value)=>{
                    if(variant.options[optionIndex]==value.trim()) {
                      found = true;
                    }
                  });
                  show = found;
                }
              }
            }
          });
        }
        if(show) {
          this.querySelector('[data-media-id="'+media.id+'"]').style.display = 'block';
        } else {
          this.querySelector('[data-media-id="'+media.id+'"]').style.display = 'none';
        }
      });

      if(this.slider) {
        this.slider.refresh();
      }
      if (this.collageGrid)
          this.updateGridLayout()
    }

    updateGridLayout() {
      const gallery = this.querySelector('.items-wrapper');
      const visibleItems = Array.from(gallery.children).filter(el => getComputedStyle(el).display !== 'none');
      gallery.querySelectorAll('.layout-100, .layout-50').forEach(el => el.classList.remove('layout-100', 'layout-50'));
      visibleItems.forEach((el, index) => el.classList.add((index % 3) === 0 ? 'layout-100' : 'layout-50'));
    }

    onVariantChange() {
    }

    onMediaChange() {
    }

    initSlider() {
    }

    removeSlider() {
      if(this.slider) {
        this.slider.destroy();
        this.slider = false;
        this.classList.remove('keen');
        this.itemsWrapper.classList.remove('keen-slider');
        this.querySelectorAll('.media-wrap, .thumb-wrap').forEach((slide)=>{
          slide.classList.remove('keen-slider-slide')
        });
      }
    }

    showItem(mediaId, animate=true) {
      if(this.slider) {
        var index = Array.from(this.itemsWrapper.querySelectorAll('.media-wrap, .thumb-wrap'))
          .filter(x=>$s.isVisible(x)).findIndex(x=>x.dataset.mediaId==mediaId);
        if(animate) {
          this.slider.moveToSlideRelative(index, true);
        } else {
          this.slider.moveToSlideRelative(index, true, 0);
        }
      }
    }
  }
  
  class ProductGallery extends ProductMedia {
    constructor() {
      super();
      this.videoAutoplay = this.dataset.videoAutoplay;
      this.autoplayOptionsElement = this.videoAutoplay ? this.querySelector('.autoplay-options') : null;
      this.autoplayCheck = this.autoplayOptionsElement ? this.autoplayOptionsElement.querySelector('input') : null;
      if (this.autoplayCheck) {
        this.autoplayCheck.addEventListener('change', (e)=>{
          Cookies.set('autoplay', e.target.checked ? 'enabled' : 'disabled');
        });
        this.autoplayCheck.checked = Cookies.get('autoplay') !== 'disabled';
      }
      this.additionalFilters = null;
      this.mainElement.addEventListener('bundleVariantChange', this.onBundleVariantChange.bind(this))

      if(!this.closest('.tingle-modal')) {
        // this.querySelectorAll('[data-file]').forEach((media)=>{
        //   media.addEventListener('click', (e)=>{
        //     var visibleItems = [];
        //     this.querySelectorAll('[data-media-id]').forEach((obj)=>{
        //       if($s.isVisible(obj)) {
        //         let element  = obj.querySelector('[data-file], video, iframe');
        //         if(element) {
        //           visibleItems.push(element);
        //         }
        //       }
        //     });
        //     $s.photoSwipe(visibleItems, media);
        //   });
        // });


        this.querySelectorAll('.image-wrap.media-wrap').forEach((imageWrap) => {

  var media = imageWrap.querySelector('[data-file]');

  if (!media) {
    return;
  }

  function openProductImage() {
    var visibleItems = [];

    this.querySelectorAll('[data-media-id]').forEach((obj) => {
      if ($s.isVisible(obj)) {
        var element = obj.querySelector('[data-file], video, iframe');

        if (element) {
          visibleItems.push(element);
        }
      }
    });

    $s.photoSwipe(visibleItems, media);
  }

  imageWrap.addEventListener('click', openProductImage.bind(this));

  imageWrap.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      openProductImage.call(this);
    }
  });

});

        //3D Models
        this.querySelectorAll('[data-media-id].model-wrap').forEach((model)=>{
          model.addEventListener('click', (e)=>{
            $s.photoSwipe([model.querySelector('template').content.firstElementChild]);         
          });
        });
      }
    }

    onBundleVariantChange(e) {
      this.additionalFilters = e.detail && e.detail.length ? 
        e.detail.map(variant => variant.bundleTitle)
        .filter(v => v)
        .reduce((tot, filter) => tot + `${filter},`, "") 
      : ""
      var variant = this.mainElement.getCurrentVariant()
      if(this.mainElement.productData.media && variant && this.additionalFilters) {
        this.filterMedia(variant, this.additionalFilters);
        if(variant.featured_media && this.mainElement.isSwatchSelected()) {
          this.showItem(variant.featured_media.id)
        }
      }
    }

    onVariantChange(e) {
      var variant = e.detail.variant;
      var animate = e.detail.animate;
      if(this.mainElement.productData.media && variant) {
        this.filterMedia(variant, this.additionalFilters);
        if(variant.featured_media && this.mainElement.isSwatchSelected()) {
          this.showItem(variant.featured_media.id, animate)
        }
      }
    }

    onMediaChange() {
      if(newProductMainMedia.isSmall() || this.desktopStyle=='carousel') {
        this.initSlider();
      } else {
        this.removeSlider();
      }
    }

    initSlider() {
      if(!this.slider) {
        this.classList.add('keen');
        this.itemsWrapper.classList.add('keen-slider');
        this.itemsWrapper.querySelectorAll('.media-wrap').forEach((slide)=>{
          slide.classList.add('keen-slider-slide')
        });

        // KeenSlider only applies the LAST matching breakpoint (options are not merged),
        // so the mobile breakpoint has to repeat the arrow buttons alongside the dots.
        var breakpoints = {};
        var navButtons = {};
        if(this.querySelector('.keen-arrow')) {
          navButtons = {
            prevButton: this.querySelector('.keen-arrow.prev'),
            nextButton: this.querySelector('.keen-arrow.next')
          };
          breakpoints['(min-width: '+(parseInt(0) + 0.001) +'rem)'] = navButtons;
        }
        if(this.mobileStyle=='dots') {
          breakpoints[newProductMainMedia.query] = {
            dots: this.querySelector('.keen-dots'),
            ...navButtons
          }
        }

        this.slider = new KeenSlider(this.itemsWrapper, {
          mode: "snap",
          loop: true,
          wheel: false,
          slideChanged: (keen)=>{
            $s.pauseAllMedia(this);
            let canPlay = true;
            if (this.autoplayOptionsElement) {
              this.autoplayOptionsElement.classList.remove('visible');
            }
            if (this.videoAutoplay) {
              const media = keen.currentSlide().querySelector('.media');
              if (this.autoplayOptionsElement && media) { //&& media is to only show the checkbox on video slides.
                this.autoplayOptionsElement.classList.add('visible');
                //TODO eval  checkbox
                this.autoplayCheck.checked = canPlay = Cookies.get('autoplay')!='disabled';
              }
              if (media && canPlay) {
                $s.playMedia(media);
              }
            }
            this.dispatchEvent(new CustomEvent('slideChanged', {detail: keen}));
          },
          breakpoints
        });
      }
    }
  }
  customElements.define('product-gallery', ProductGallery);

  class ProductThumbs extends ProductMedia {
    constructor() {
      super();
      this.mainGallery = this.mainElement.querySelector('product-gallery');

      this.querySelectorAll('[data-media-id]').forEach((media)=>{
        media.addEventListener('click', (e)=>{
          this.mainGallery.showItem(media.dataset.mediaId);
        });
      });

      this.mainGallery.addEventListener('slideChanged', (e)=>{
        var currentSlide = e.detail.currentSlide();
        if(currentSlide) {
          var currentMediaId = currentSlide.dataset.mediaId;
          var currentSlideElement = this.querySelector('.current-slide');
          if(currentSlideElement) {
            currentSlideElement.classList.remove('current-slide');
          }
          this.querySelector('[data-media-id="'+currentMediaId+'"]').classList.add('current-slide');
          this.showItem(currentMediaId);
        }
      });
    }

    onVariantChange(e) {
      var variant = e.detail.variant;
      if(this.mainElement.productData.media && variant) {
        this.filterMedia(variant)
      }
    }

    onMediaChange() {
      if((newProductMainMedia.isSmall() && this.mobileStyle=='thumbnails') || (!newProductMainMedia.isSmall() && (this.desktopStyle=='carousel') )) {
        this.style.display = 'block';
        this.initSlider();
      } else {
        this.style.display = 'none';
        this.removeSlider();
      }
    }

    initSlider() {
      if(!this.slider) {
        this.classList.add('keen');
        this.itemsWrapper.classList.add('keen-slider');
        this.itemsWrapper.querySelectorAll('.thumb-wrap').forEach((slide)=>{
          slide.classList.add('keen-slider-slide')
        });
        var breakpoints = {};
        breakpoints['(max-width: '+window.breakpoints.medium+')'] = {
          slidesPerView: 6,
          spacing: 10,
          centered: false,
          vertical: false
        }
        breakpoints[newProductMainMedia.query] = {
          slidesPerView: 6,
          spacing: 10,
          centered: false,
          vertical: false,
        }
        this.slider = new KeenSlider(this.itemsWrapper, {
          mode: "snap",
          loop: true,
          centered: false,
          slidesPerView: 6,
          spacing: 15,
          prevButton: this.querySelector('.keen-arrow.prev'),
          nextButton: this.querySelector('.keen-arrow.next'),
          breakpoints,
          ...(this.desktopOrientation=='vertical' ? {
            vertical: true,
            slidesPerView: 5
          } : {})
        });
      }
    }
  }
  customElements.define('product-thumbs', ProductThumbs);
}

if(!customElements.get('product-price')) {
  class ProductPrice extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.finalPriceElement = this.querySelector('.final');
      this.comparePriceElement = this.querySelector('.compare');
      this.multiplyQuantity = typeof(this.dataset.multiplyQuantity)!='undefined' ? this.dataset.multiplyQuantity=='true' : false;

      this.enableBundlePricing = this.dataset.enableBundlePricing === 'true';
      this.bundleDiscount = !isNaN(parseInt(this.dataset.bundleDiscount)) ? parseInt(this.dataset.bundleDiscount) : 0;
      this.bundleDiscountType = this.dataset.bundleDiscountType;
      this.bundleSavingsText = this.dataset.savingsText;
      this.bundleCompareAtPrice = !isNaN(parseFloat(this.dataset.bundleCompareAtPrice)) ? parseFloat(this.dataset.bundleCompareAtPrice) : 0;

      this.additionalPricingElements = [];
      this.badgeSale = this.closest('.module')?.querySelector('.product-badges .badge.sale');

      if(this.mainElement.classList.contains('product-card')){
        var originalPricePrefix = '<span class="visually-hidden">Original price: </span>'
        var finalPricePrefix = '<span class="visually-hidden">. Final price: </span>'
      } else {
        var originalPricePrefix = '<span class="visually-hidden">Original price: </span>'
        var finalPricePrefix = '<span class="visually-hidden">. Final price: </span>'
      }

      this.listenEvents = ['variantChange','sellingPlanChange'];
      if (this.enableBundlePricing) this.listenEvents = [...this.listenEvents, 'bundleVariantChange'];

      if (this.multiplyQuantity)
        this.listenEvents.splice(1, 0, 'quantityChange');

      
      
      this.listenEvents.forEach((event)=>{ 
        this.mainElement.addEventListener(event, (e)=>{

          if (this.enableBundlePricing && e.type == 'bundleVariantChange') {
            this.additionalPricingElements = e.detail;
          }

          var data = this.mainElement.getCurrentPlan() || this.mainElement.getCurrentVariant();
        	if(data) {
            var quantity = this.multiplyQuantity ? this.mainElement.getQuantity() : 1;

            var price = data.price;
            if (this.enableBundlePricing) {
              
              price = this.additionalPricingElements.reduce((total, additionalElement) => total + parseInt(additionalElement.price), price)
              
              if (this.bundleDiscount > 0) {
                var compareAtPrice = price; 
                var discountedPrice = 0;
                var savings = 0;
                if (this.bundleDiscountType == 'percentage') {
                  discountedPrice = price * (1 - (this.bundleDiscount / 100))
                  savings = this.bundleDiscount;
                } else {
                  discountedPrice = price - (this.bundleDiscount * 100);
                  savings = this.bundleDiscount;
                }
                this.comparePriceElement.classList.remove('hide');
                this.comparePriceElement.innerHTML = originalPricePrefix + $s.formatMoney(compareAtPrice * quantity).replace('.00','');
                this.finalPriceElement.innerHTML = finalPricePrefix + $s.formatMoney(discountedPrice * quantity).replace('.00','');
                if (this.badgeSale) {
                  this.badgeSale.innerHTML = this.bundleSavingsText.replace('[[AMOUNT]]', savings);
                  this.badgeSale.style.display = 'inline-block'
                }
              } else if (this.bundleCompareAtPrice > 0) {
                var compareAtPrice = this.bundleCompareAtPrice;
                var discountedPrice = this.bundleCompareAtPrice - price;
                var savings = (discountedPrice / this.bundleCompareAtPrice) * 100;
                this.comparePriceElement.classList.remove('hide');
                this.comparePriceElement.innerHTML = originalPricePrefix + $s.formatMoney(compareAtPrice * quantity).replace('.00','');
                this.finalPriceElement.innerHTML = finalPricePrefix + $s.formatMoney(price * quantity).replace('.00','');
                if (this.badgeSale) {
                  this.badgeSale.innerHTML = this.badgeSale.dataset.msgtpl.replace('[percent]', Math.floor(savings));
                  this.badgeSale.style.display = 'inline-block'
                }
              } else {
                this.comparePriceElement.classList.add('hide');
                this.finalPriceElement.innerHTML = $s.formatMoney(price * quantity).replace('.00','');
                if (this.badgeSale) {
                  this.badgeSale.style.display = 'none'
                }
              }
              
            }
            else {
              this.finalPriceElement.innerHTML = $s.formatMoney(price * quantity).replace('.00','');
              var compareAtPrice = data.compare_at_price;
              if(compareAtPrice > data.price) {
                this.comparePriceElement.classList.remove('hide');
                this.comparePriceElement.innerHTML = originalPricePrefix + $s.formatMoney(compareAtPrice * quantity).replace('.00','');
                this.finalPriceElement.innerHTML = finalPricePrefix + $s.formatMoney(data.price * quantity).replace('.00','');
              } else {
                this.comparePriceElement.classList.add('hide');
                this.comparePriceElement.innerHTML = '';
              }
            }
        		
        	} else {
        		this.finalPriceElement.innerHTML = '';
            this.comparePriceElement.innerHTML = '';
        	}
          this.mainElement.dispatchEvent(new CustomEvent('priceChange', {detail: {price: data.price * quantity}}));
        });
      });
    }
  }
  customElements.define('product-price', ProductPrice);
}

if(!customElements.get('product-variants')) {
  class ProductVariants extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.mainElement.variantsInstances = (this.mainElement.variantsInstances || 0) +1;
      this.instanceIndex = this.mainElement.variantsInstances;
      this.variantInput = this.querySelector('[data-variant-id]');
      this.options = this.querySelectorAll('[data-option]');
      this.swatchImg = this.querySelector('product-swatch[data-use-img="true"]');
      this.variantsInfo = this.dataset.info ? JSON.parse(this.dataset.info) : null;
      this.mainElement.addEventListener('variantChange', (event)=> {
        if (this.variantInput.value != event.detail.variant.id) {
          this.setVariant(event.detail.variant);
        }
      })

      this.bindOptions();
      setTimeout(()=>{
        this.variantChange(this.getCurrentVariant(), false);
        this.bindInfoElements();
      }, 10);
    }

    getOptionInfo(optionName) {
      return (this.variantsInfo ? this.variantsInfo.find(x=>x.title==optionName) : null) || {};
    }

    getOptionInfoIcon(optionName) {
      var info = this.getOptionInfo(optionName);
      var html = '';
      if (info.description) {
        html = `
          <div class="option-info-icon">
            <button type="button" class="btn-open">?</button>
            <div class="option-info-content animation">${info.description}</div>
          </div>
        `;
      }

      return html;
    }
    getOptionInfoLink(optionName) {
      var info = this.getOptionInfo(optionName);
      var html = '';
      if (info.link_text) {
        if (info.link_target_image) {
          html = `
            <button type="button" class="option-info-link link" data-image-width="${info.link_target_image_native_width}" data-image-height="${info.link_target_image_native_height}" data-image="${info.link_target_image}" data-width="${info.link_target_image_width}">${info.link_text}</button>
          `;
        } else {
          html = `
            <a class="option-info-link link" href="${info.link_target_url}" target="_blank">${info.link_text}</a>
          `;
        }

      }

      return html;
    }

    getCurrentVariant() {
      return this.mainElement.productData.variants.find(x=>x.id==this.variantInput.value)
    }

    setVariant(variant) {
      if(typeof variant !== 'object') {
        variant = this.mainElement.productData.variants.find(x=>x.id==variant);
      }
      if(variant) {
        this.refreshOptions(-1, variant);
        this.variantChange(variant);
      }
    }

    variantChange(variant, animate=true) {
      if(variant) {
        this.variantInput.value = variant.id;
      } else {
        this.variantInput.value = '';
      }
      this.previousVariant = variant;
      this.variantInput.dispatchEvent(new Event('change', {bubbles: true}))
      this.mainElement.dispatchEvent(new CustomEvent('variantChange', {detail: {variant, animate}}));

      if (this.swatchImg) {
          //var variant = this.mainElement.productData.variants.
          var options = ['option1', 'option2', 'option3'];
          var imgOption = options.splice(this.swatchImg.dataset.option/1 -1 ,1);
          var imgSize = this.swatchImg.dataset.imgSize || '80x';
          var imgWidth = parseInt(imgSize, 10) || 80;
          this.swatchImg.querySelectorAll('[type="radio"]').forEach(radio=>{
            var label = radio.parentNode.querySelector('.label-inner');
            
            var matchingVariant = this.mainElement.productData.variants.find(v=>v[imgOption]==radio.value && v[options[0]]==variant[options[0]] && v[options[1]]==variant[options[1]]);
            if (!matchingVariant) {
              matchingVariant = this.mainElement.productData.variants.find(v=>v[imgOption]==radio.value);
            }
            let img = label.querySelector('img');
            if (matchingVariant.featured_image) {
              if (!img) {
                img = document.createElement('img');
                img.loading = 'lazy';
                img.width = imgWidth;
                img.height = imgWidth;
                img.alt = '';
                label.appendChild(img);
              }
              img.src = $s.imgUrlFilter(matchingVariant.featured_image.src, imgSize);
              img.style.display = '';
            } else {
              if (img) {
                img.style.display = 'none';
              }
            }
          });

      }

    }

    calculateNewVariant(optionChanged, value) {
      var newVariants = this.mainElement.productData.variants;
      this.mainElement.productData.options.forEach((option, index)=>{
        if(optionChanged==index) {
          newVariants = newVariants.filter(x=>x.options[index]==value);
        } else {
          var tmpNewVariants = newVariants.filter(x=>x.options[index]==this.previousVariant.options[index]);
          if(tmpNewVariants.length==0) {
            tmpNewVariants = newVariants.filter(x=>x.options[index]==newVariants[0].options[index]);
          }
          newVariants = tmpNewVariants;
        }
      });
      return newVariants[0];
    }

    bindOptions() {
      this.options.forEach((element)=>{
        element.addEventListener('change', (e)=>{
          let optionIdx = element.dataset.option-1;
          let variant = this.calculateNewVariant(optionIdx, e.target.value);
          this.refreshOptions(element.dataset.option-1, variant);
          this.variantChange(variant);
        });
      });
    }

    bindInfoElements() {
      this.options.forEach((element)=>{
        var infoIcon = element.querySelector('.option-info-icon');
        var infoLink = element.querySelector('button.option-info-link');
        if (infoIcon) {
          $s.initFloatingPanel({container: infoIcon});
        }
        if (infoLink) {
          infoLink.addEventListener('click', (e)=>{
            var imageWidthPX = parseFloat(getComputedStyle(document.documentElement).fontSize) * infoLink.dataset.width;
            var html = `
              <div class="option-info-popup-content" style="width: ${infoLink.dataset.width}rem">
                <img src="${infoLink.dataset.image + (infoLink.dataset.image.indexOf('?')==-1 ? '?' : '&') + 'width='+imageWidthPX}" width="${infoLink.dataset.imageWidth}" height="${infoLink.dataset.imageHeight}" />
              </div>
            `;
            $s.openModal(html, 'option-info-popup');
          });
        }
      });
    }

    getOptionValues(currentVariant) {
      var options = [];
      this.mainElement.productData.options.forEach((option, index)=>{
        if(index==0) {
          var optionValues = this.mainElement.productData.variants.map((variant)=>{return {
            value: variant.options[index], 
            available: variant.available
          }});
        }
        if(index==1) {
          var optionValues = this.mainElement.productData.variants.filter(x=>x.options[0]==currentVariant.option1).map((variant)=>{return {
            value: variant.options[index],
            available: variant.available
          }});
        }
        if(index==2) {
          var optionValues = this.mainElement.productData.variants.filter(
            x=>x.options[0]==currentVariant.option1 && x.options[1]==currentVariant.option2
          ).map((variant)=>{return {
            value: variant.options[index],
            available: variant.available
          }});
        }
        var optionValuesUnique = [];
        optionValues.forEach((option, key)=>{
          if(!optionValuesUnique.find(x=>x.value==option.value)) {
            if(option.available) {
              optionValuesUnique.push(option);
            } else {
              if(!optionValues.find((x,y)=>y!=key && x.available && x.value==option.value)) {
                optionValuesUnique.push(option);
              }
            }
          }
        });
        options.push(optionValuesUnique);
      });
      return options;
    }

    refreshOptions(updateOptionIndex=-1, currentVariant) {
      var optionValues = this.getOptionValues(currentVariant);
      this.options.forEach((element)=>{
        let index = element.dataset.option - 1;
        if(index > updateOptionIndex) {
          element.buildOptions(optionValues[index], currentVariant.options[index]);
        }
        var optionValueElement = element.querySelector('.option-value');
        if(optionValueElement) {
          optionValueElement.innerHTML = currentVariant.options[index];
        }
      });
    }
  }
  customElements.define('product-variants', ProductVariants);
}

if(!customElements.get('product-variant-edit')) {
  class ProductVariantEdit extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.toggles = this.querySelectorAll('.toggle');
      this.toggles.forEach(btn=>{btn.addEventListener('click', this.onToggle.bind(this))});
      this.editing = false;
    }
    onToggle() {
      this.editing = !this.editing;
      var divVariants = this.querySelector('.variants');
      var divInfo = this.querySelector('.info');
      if (this.editing) {
        $s.expand([divVariants]);
        this.toggles.forEach(btn=>{btn.classList.add('open')});
      } else {
        $s.collapse([divVariants]);
        this.toggles.forEach(btn=>{btn.classList.remove('open')});
      }
    }
  }
  customElements.define('product-variant-edit', ProductVariantEdit);
}

if(!customElements.get('product-swatch')) {
  class ProductSwatch extends HTMLElement {
  	constructor() {
      super();
      this.colorSwatchesOptions = ["Color","Camera Color","Bag Color","Couleur","Farbe","Kleur","Colore","צֶבַע","Wählen","Couleur de la caméra","Couleur du sac","Carver Mat 10\" (Color)","Kamerafarbe","Couleur de la caméra","Tapis de sculpture 10","Carver Mat 10","Tapis de sculpture 10 (couleur)","Camp Snap Camera (Screen-Free Digital Camera) (Color)","Material","Camera Bag (Fits Camp Snap \u0026 CS-Pro) (Color)","Camp Snap 2 (Screen-Free Digital Camera) (Color)","Select Camera Bag (Fits Camp Snap \u0026 CS-Pro) (Color)","Select Camp Snap 2 (Screen-Free Digital Camera) (Color)","Sleeping Bag Camera Carrying Case (Color)"]
      this.mainElement = this.closest('.product-main-element');
      this.variantsElement = this.closest('product-variants') || this.mainElement.querySelector('product-variants');
      this.optionNumber = this.dataset.option;
      this.label = this.dataset.label;
      this.displayLabel = this.dataset.displayLabel;
      this.infoIcon = this.variantsElement.getOptionInfoIcon(this.label) || '';
      this.infoLink = this.variantsElement.getOptionInfoLink(this.label) || '';
      this.setAttribute('aria-labelledby', `swatchgroup-${this.optionNumber}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}`);
      this.prepend = this.dataset.prepend;

      this.buildOptionSelector();
        console.log('variantsElement', this.variantsElement);
    }

    required(newValue) {
      return this.mainElement.required(this.label, newValue);
    }

    buildOptionSelector() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
      var defaultValue = currentVariant.options[this.optionNumber-1];
    	var optionElement = document.createElement('div');
      var mainElementId = this.mainElement.dataset.productId;
      var optionNameHandle = $s.handleize(this.label);
  		var html = `
        <div class="option-name">
          ${this.infoIcon}
          <span id="${this.getAttribute('aria-labelledby')}">${this.prepend ? `${this.prepend} ` : ''}${this.displayLabel ? this.displayLabel.replace('[b]', '<strong>').replace('[/b]', '</strong>') : this.label}: </span>
          <span aria-hidden="true" class="option-value">${defaultValue}</span>
          ${this.infoLink}
        </div>
        <div class="swatch-group flex flex-wrap"></div>
  		`;
  		this.innerHTML = html;
  		this.buildOptions(optionValues, defaultValue, currentVariant);
    }

    buildOptions(options, defaultValue, currentVariant) {
    	var html = '';
      if (options.length > 0) {
        this.setAttribute('role', 'radiogroup');
      }

  		options.forEach((option, index)=>{
        var optionNameHandle = $s.handleize(this.label);
        var optionValueHandle = $s.handleize(option.value);
        var id = `swatch-${this.optionNumber}-${$s.handleize(option.value)}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}`;
        var soldOut = (!option.available ? '<span class="visually-hidden"> (Sold Out)</span>' : '');
        // Get swatch values from metaobject items
        let swatchEl = document.querySelector(`.varaint_item[data-value="${option.value}"]`);

        let swatchColor = swatchEl?.getAttribute('data-color') || null;
        let swatchImg   = swatchEl?.getAttribute('data-image') || null;
        
        let hideEl = document.querySelector(`.bundle-varaint-data[data-value="${option.value}"]`);

    
        let variantHide = hideEl?.getAttribute('data-hide') === 'true';

       

          // ❗ Skip if hidden
          if (variantHide) {
            return;
          }

        // Build dynamic style
        let styleAttr = '';
        if (swatchImg) {
          styleAttr = `background-image:url('${swatchImg}');background-size:cover;background-position:center;`;
        } else if (swatchColor) {
          styleAttr = `background-color:${swatchColor};`;
        }

        html += `
          <div class="swatch" data-available="${option.available}">
            <input 
              type="radio" 
              id="${id}" 
              name="swatch-${this.optionNumber}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}" 
              value="${$s.escapeDomAttribute(option.value)}"
            />

            <label for="${id}">
              <div 
                class="label-inner flex align-items-center justify-content-center animation  
                ${this.colorSwatchesOptions.indexOf(this.label) ? 'color-'+optionValueHandle : ''} 
                ${optionNameHandle}-${optionValueHandle}"
                style="${styleAttr}"
              >
                <span>${option.value}${soldOut}</span>               
              </div>
            </label>
          </div>
        `;

  		});
  		var group = this.querySelector('.swatch-group');
  		group.innerHTML = html;

      if (this.required()) {
        this.setAttribute('data-required', 'true');
        group.addEventListener('change', ()=>{
          this.setAttribute('data-required', 'false');
          this.required(false);
        }, {once: true})
      } else {
        this.setAttribute('data-required', 'false');
        if(defaultValue && group.querySelector('input[value="'+$s.escapeJsDomAttribute(defaultValue)+'"]')) {
          group.querySelector('input[value="'+$s.escapeJsDomAttribute(defaultValue)+'"]').checked = true;
        } else {
          group.querySelector('input').checked = true;
        }
      }
    }
  }
  customElements.define('product-swatch', ProductSwatch);
}

if(!customElements.get('product-dropdown')) {
  class ProductDropdown extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.variantsElement = this.closest('product-variants') || this.mainElement.querySelector('product-variants');
      this.optionNumber = this.dataset.option;
      this.label = this.dataset.label;
      this.displayLabel = this.dataset.displayLabel;
      this.infoIcon = this.variantsElement.getOptionInfoIcon(this.label) || '';
      this.infoLink = this.variantsElement.getOptionInfoLink(this.label) || '';
      this.prepend = this.dataset.prepend;

      this.buildOptionSelector();

      if (this.required()) {
        var select = this.querySelector('select');
        this.setAttribute('data-required', 'true');
        select.addEventListener('change', ()=>{
          this.setAttribute('data-required', 'false');
          this.required(false);
          select.querySelector('[disabled]').remove();
        }, {once: true})
      }
    }

    buildOptionSelector() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
      var defaultValue = currentVariant.options[this.optionNumber-1];

      var optionId = 's-' + this.mainElement.sectionId+'-option-'+this.optionNumber + '-' + this.variantsElement.instanceIndex;
      var optionElement = document.createElement('div');
      var html = `
        <label class="option-name" for="${optionId}">
        ${this.infoIcon}${this.prepend ? `${this.prepend} ` : ''}${this.displayLabel ? this.displayLabel.replace('[b]', '<strong>').replace('[/b]', '</strong>') : this.label}: 
        ${this.infoLink}
        </label>
        <div class="field">
          <svg aria-hidden="true" class="icon icon-arrow-down" viewBox="0 0 32 32"><path class="stroke" d="M27,10,16,22,5,10"/></svg> 
          <select id="${optionId}" name="swatch-${optionId}"></select>
        </div>
      `;
      this.innerHTML = html;
      this.buildOptions(optionValues, defaultValue);
    }

    required(newValue) {
      return this.mainElement.required(this.label, newValue);
    }

    buildOptions(options, defaultValue) {
    	var html = '';
      if (this.required()) {
  			html += `<option value="${defaultValue || ''}" disabled selected>${lngg.general__forms__select_option_label}</option>`;
      } else {
        this.setAttribute('data-required', 'false');
      }
  		options.forEach((option, index)=>{
  			let soldOut = (!option.available ? lngg.product_main__sold_out_option_value : '');
  			html += `<option value="${$s.escapeDomAttribute(option.value)}">${option.value}${soldOut}</option>`;
  		});
  		var select = this.querySelector('select');
  		select.innerHTML = html;

  		if(defaultValue) {
    		var newValueIndex = Array.from(select.options).findIndex(x=>x.value==defaultValue);
    		if(newValueIndex>=0) {
    			select.selectedIndex = newValueIndex;
    		}
  		}
    }
  }
  customElements.define('product-dropdown', ProductDropdown);
}

if(!customElements.get('product-model')) {
  class ProductModel extends HTMLElement {
    constructor() {
      super();
      this.mainElement = document.querySelector('.product-main-element[data-product-id="'+this.dataset.productId+'"]');

      window.Shopify.loadFeatures([{
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXr.bind(this)
      }]);
    }

    setupShopifyXr() {
      if(!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', ()=>{
          this.setupShopifyXr();
        });
      } else {
        window.ShopifyXR.addModels(this.mainElement.productData.media.filter(x=>x.media_type=='model'));
        setTimeout(()=>{
          window.ShopifyXR.setupXRElements();
        }, 100);
      }
    }
  }
  customElements.define('product-model', ProductModel);
}

if(!customElements.get('product-sticky-panel')) {
  class ProductStickyPanel extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.scrollHandler = $s.throttle(this.onScroll.bind(this), 50);
      this.positionElement = this.mainElement.querySelector('.product-sticky-panel-position-placeholder');
    }

    connectedCallback() {
      this.applyApplePayGate();
      if (this.positionElement) {
        window.addEventListener('scroll', this.scrollHandler);
        this.onScroll();
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.scrollHandler);
    }

    onScroll(event) {
      var bounds = this.positionElement.getBoundingClientRect();
      // Show whenever the ATC block is not visible in the viewport at all -
      // scrolled past it (below) OR not yet reached it (above).
      var inView = bounds.bottom > 0 && bounds.top < window.innerHeight;
      if (inView) {
        if (this.showing) {
          this.classList.remove('open');
          this.showing = false;
        }
      } else {
        if (!this.showing) {
          this.classList.add('open');
          this.showing = true;
        }
      }

    }

    // The sticky bar should only ever show Apple Pay, never Shop Pay/other wallet
    // fallbacks - Shopify's payment_button filter has no Liquid-level way to restrict
    // which wallet it recommends, so gate it client-side via ApplePaySession feature
    // detection. The button itself is rendered directly here in Liquid (see
    // sections/product_main.liquid) - if Apple Pay isn't available, remove it before it
    // ever paints, leaving Add to Cart alone. Runs once on connect.
    applyApplePayGate() {
      var target = this.querySelector('.sticky-payment-button-target[data-apple-pay-only]');
      if (!target) return;

      var canApplePay = !!(window.ApplePaySession && ApplePaySession.canMakePayments && ApplePaySession.canMakePayments());
      if (canApplePay) {
        var row = target.closest('.sticky-atc-row');
        if (row) row.classList.add('has-payment-button');
      } else {
        target.remove();
      }
    }

  }
  customElements.define('product-sticky-panel', ProductStickyPanel);
}

if(!customElements.get('pickup-availability')) {
  class PickupAvailability extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');

      this.mainElement.addEventListener('variantChange', (e)=>{
        if(e.detail.variant && e.detail.variant.available) {
          this.fetchAvailability(e.detail.variant.id);
        } else {
          this.innerHTML = '';
        }
      });
    }

    fetchAvailability(variantId) {
      let rootUrl = routes.root_url;
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup_availability`;

      $s.get({
        url: variantSectionUrl,
        success: (data)=>{
          this.innerHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('.shopify-section').innerHTML;
          this.bindEvents();
        },
        error: ()=>{
          this.innerHTML = '';
        }
      });
    }

    bindEvents() {
      let button = this.querySelector('.pickup-popup-trigger');
      if(button) {
        button.addEventListener('click', ()=>{
          $s.openModal(this.querySelector('.pickup-availability-info'), 'pickup-availability-info-modal');
        });
      }
    }
  }
  customElements.define('pickup-availability', PickupAvailability);
}






if(!customElements.get('vintage-footage')) {
  // Overlay that plays one video per vintage filter; picking a filter swaps the video and plays it from the start.
  class VintageFootage extends HTMLElement {
    connectedCallback() {
      if(this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('.vf-dialog');
      this.stage = this.querySelector('.vf-stage');
      this.stageBg = this.querySelector('.vf-stage-bg');
      this.wrap = this.querySelector('.vf-video-wrap');
      this.video = this.querySelector('.vf-video');
      this.nameEl = this.querySelector('.vf-filter-name');
      this.thumbs = Array.from(this.querySelectorAll('.vf-thumb'));
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.current = null;
      this.opener = null;

      const host = this.closest('.gallery-wrap') || document;
      host.querySelectorAll('[data-vintage-footage-open]').forEach((btn)=>{
        btn.addEventListener('click', ()=>this.open(btn));
      });
      this.querySelector('[data-vintage-footage-close]').addEventListener('click', ()=>this.dialog.close());
      this.dialog.addEventListener('close', ()=>this.onClose());
      this.stage.addEventListener('click', ()=>this.togglePlayback());
      this.thumbs.forEach((btn)=>{
        btn.addEventListener('click', (e)=>{
          e.stopPropagation();
          this.select(btn);
        });
      });
      this.video.addEventListener('loadedmetadata', ()=>{
        if(this.video.videoWidth && this.video.videoHeight) {
          this.wrap.style.setProperty('--vf-ar', this.video.videoWidth / this.video.videoHeight);
        }
      });
    }

    open(opener) {
      this.opener = opener;
      this.dialog.showModal();
      document.documentElement.classList.add('vf-lock');
      if(!this.current) {
        this.select(this.thumbs[0], !this.reducedMotion);
      } else if(!this.reducedMotion) {
        this.play();
      }
    }

    onClose() {
      document.documentElement.classList.remove('vf-lock');
      this.video.pause();
      if(this.opener) this.opener.focus();
    }

    select(btn, autoplay) {
      if(!btn) return;
      if(typeof autoplay === 'undefined') autoplay = !this.video.paused;
      this.current = btn;
      this.thumbs.forEach((thumb)=>{
        thumb.setAttribute('aria-pressed', thumb === btn ? 'true' : 'false');
      });
      this.nameEl.textContent = btn.dataset.title;
      this.stageBg.src = btn.dataset.bg;
      this.video.poster = btn.dataset.poster;
      this.video.src = btn.dataset.src;
      if(autoplay) this.play();
    }

    play() {
      const promise = this.video.play();
      if(promise && promise.catch) promise.catch(()=>{});
    }

    togglePlayback() {
      if(this.video.paused) {
        this.play();
      } else {
        this.video.pause();
      }
    }
  }
  customElements.define('vintage-footage', VintageFootage);
}

// Stock status of a variant from inventory: 'available', 'preorder' or 'sold_out'
function getVariantStockStatus(mainElement, variant) {
  if (!variant) return 'sold_out';
  const ids = (name) => (mainElement.dataset[name] || '').split(',');
  if (ids('soldOutVariantIds').includes(String(variant.id))) return 'sold_out';
  if (ids('preorderVariantIds').includes(String(variant.id))) return 'preorder';
  return 'available';
}

if(!customElements.get('variant-sold-out-banner')) {
  class VariantSoldOutBanner extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      if (this.mainElement) {
        this.mainElement.addEventListener('variantChange', (e)=>this.update(e.detail.variant));
      }
    }

    update(variant) {
      if (this.dataset.forceShow) return;
      const preorder = getVariantStockStatus(this.mainElement, variant) === 'preorder';
      this.classList.toggle('is-hidden', !preorder);
    }
  }
  customElements.define('variant-sold-out-banner', VariantSoldOutBanner);
}

if(!customElements.get('variant-stock-status')) {
  class VariantStockStatus extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.setStatus(this.dataset.status);
      if (this.mainElement) {
        this.mainElement.addEventListener('variantChange', (e)=>{
          this.setStatus(getVariantStockStatus(this.mainElement, e.detail.variant));
        });
      }
    }

    setStatus(status) {
      this.dataset.status = status;
      // Hide the whole callout when there's no text for this status
      const text = this.querySelector(`[data-stock-status="${status}"]`);
      this.classList.toggle('is-empty', !text || !text.textContent.trim());
    }
  }
  customElements.define('variant-stock-status', VariantStockStatus);
}

// The shopify-payment-terms element renders inside an open shadow root that sets its own font,
// so outside CSS can't reach it. Inject a stylesheet into the shadow root so it inherits
// the callout's font instead.
(function() {
  const SELECTOR = '.product-callouts shopify-payment-terms';
  const CSS = ':host, :host * { font-family: inherit !important; font-size: inherit !important; }';
  const supportsAdopted = 'adoptedStyleSheets' in Document.prototype && 'replaceSync' in CSSStyleSheet.prototype;
  let sheet = null;

  function applyStyles(root) {
    if (supportsAdopted) {
      if (!sheet) {
        sheet = new CSSStyleSheet();
        sheet.replaceSync(CSS);
      }
      if (!root.adoptedStyleSheets.includes(sheet)) {
        root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];
      }
    } else if (!root.querySelector('style[data-callout-styles]')) {
      const style = document.createElement('style');
      style.setAttribute('data-callout-styles', '');
      style.textContent = CSS;
      root.appendChild(style);
    }
  }

  function styleTerms(el, attempts = 0) {
    if (el.shadowRoot) {
      applyStyles(el.shadowRoot);
      if (!supportsAdopted && !el.dataset.calloutObserved) {
        // Fallback style tag gets wiped if Shopify re-renders the shadow content
        el.dataset.calloutObserved = 'true';
        new MutationObserver(() => applyStyles(el.shadowRoot)).observe(el.shadowRoot, { childList: true });
      }
    } else if (attempts < 60) {
      requestAnimationFrame(() => styleTerms(el, attempts + 1));
    }
  }

  function styleAll() {
    document.querySelectorAll(SELECTOR).forEach((el) => styleTerms(el));
  }

  customElements.whenDefined('shopify-payment-terms').then(() => {
    styleAll();
    new MutationObserver((mutations) => {
      if (mutations.some((m) => m.addedNodes.length)) styleAll();
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
